<template>
  <ms-dynamic-popup
    title="Tham số in chứng từ"
    classTitle="report-param-title"
    :width="700"
    dockPosition="right"
    @beforeOpen="beforeOpen($event, close)"
    @beforeClose="beforeClose"
    classDetail="report-param-C4-08KB-TT19-2020"
    @shortkeyAction="shortkeyAction"
    :name="'C408_KB_TT19'"
    ><template v-slot:icon>
      <a
        class="button icon24 ic-question mr-2"
        v-tooltip="'Trợ giúp'"
        shortkey-target="Help"
        target="_blank"
        :href="linkHelp($ms.constant.Help.VoucherReport)"
      ></a>
    </template>
    <template v-slot:content>
      <div class="flex flex-column">
        <div class="report-title mt-1 ml-3 mr-3">
          <ms-checkbox
            class="flex1 left"
            label="Cộng gộp các bút toán giống nhau"
            v-model="model.is_summary_same"
          ></ms-checkbox>
        </div>
      </div>
    </template>
    <template v-slot:footer="{close}">
      <div class="h-100 flex-between flex1">
        <div></div>
        <div class="d-flex" style="flex-direction: row-reverse">
          <ms-button text="Đồng ý" @click="commandClick($ms.constant.Command.Ok)"></ms-button>
          <ms-button
            text="Hủy"
            type="outline-button"
            v-tooltip="'Hủy (Ctrl + H)'"
            shortkey-target="Cancel"
            hasBorder
            @click="close"
            style="margin-right: 10px"
          ></ms-button>
        </div>
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import {defineComponent, getCurrentInstance, reactive, ref, onMounted, watch, computed, nextTick} from 'vue';
import baseReportParam from '@/views/base/baseReportParam';
import {ModuleContext} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import api from '@/apis/report/voucherReportPrintAPI';
import {showError} from '@/commons/globalMessage';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import {useInforCommons} from '@/views/utility/commons/inforCommons.js';
import {collectionMonitor} from '@/setup/utilities/monitor';
import {ModuleOfflineWork} from '@/stores/moduleConst';
import _ from 'lodash';

export default defineComponent({
  components: {
    msGridEditor,
  },
  extends: baseReportParam,
  setup() {
    const {proxy} = getCurrentInstance();
    const comboboxDataRemote = reactive({});
    const {getModuleByRefType} = useInforCommons();
    const model = reactive({
      is_summary_same: false,
    });
    proxy._gridDetails = {
      details: 'Details',
    };

    /**
     * Mặc định lấy theo ref_id
     * Các form override lại nếu cần theo reftype
     * @returns
     */
    function getParamKey() {
      return `${proxy._formParam?.ref_id}`;
    };

    /**
     * Lấy tham số báo cáo lần gần nhất
     * @param {*} formName
     * @returns
     * NCPHUOC 18/08/2022
     * Modified by NVTUAN1: Lấy thêm tham số chung cho báo cáo không phân biệt mẫu ngang, mẫu dọc, ...
     */
    async function loadRecentData(formName) {
      //TODO
      const me = this;
      const refType = me._formParam.ref_type,
        reportId = me._formParam.report_id,
        paramKey = me.getParamKey(),
        reportIdCommon = me.reportIdCommon || this._formName; //Id chung cho báo cáo (mẫu ngang, mẫu dọc, ...)
      let data = {};
      const res = await api.getRecentParam(paramKey, refType, reportId, reportIdCommon);

      const { detailKey } = me._formParam;
      if (res) {

        const { master, format, common } = res;

        if (master) {
          const masterObj = JSON.parse(master);
          Object.assign(data, masterObj);
        }

        if (format) {
          me.assignFormatRecentData(data, format);
        }

        if (common) {
          me.assignCommonRecentData(data, common);
        }

        const details = [];
        data.detailParams = details;
        delete data[detailKey];
      } else {
        data = { ...me._formParam };
        data.detailParams = [...data[detailKey]];
        delete data[detailKey];
      }

      return data;
    };

        /**
     * Custom dữ liệu lưu chung theo loại chứng từ
     * @param {*} data 
     * @param {*} format 
     */
    function assignFormatRecentData(data, format) {
      Object.assign(data, JSON.parse(format));
    };

    /**
     * Custom dữ liệu lưu chung theo báo cáo không phân biệt mẫu ngang, mẫu dọc
     * @param {*} data 
     * @param {*} common 
     * NVTUAN1 24.04.2023
     */
    function assignCommonRecentData(data, common) {
      Object.assign(data, JSON.parse(common));
    };

    /**
     * overide Đẩy dữ liệu lên monitor
     * @param {*} command
     */
    function pushTrans(command) {
      const {pushTrans} = collectionMonitor();
      const me = proxy;
      var screenName = '';
      var strModule = '';
      if (me._report && me.screenCode == '') {
        if (me._report.report_id) {
          me.screenCode = me._report.report_id.replace(
            /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
            '',
          ); // Code không để ký tự đặc biệt
        }
        screenName = me._report.report_name;
        strModule = me._report.module;
      }
      pushTrans(command, screenName, strModule ? `${strModule}.${me.screenCode}` : me.screenCode);
    }

    async function bindData(data) {
      data.ref_type = proxy._formParam?.ref_type;
      data.ref_id = proxy._formParam?.ref_id;

      data.RefType = proxy._formParam?.ref_type;
      data.RefID = proxy._formParam?.ref_id;

      proxy.super('bindData', baseReportParam, data);
      proxy.model.is_summary_same = data.is_summary_same;
    }

    /**
     * Gọi sang hàm close để load lại menu print
     * dqvinh 24.11.2023
     */
    function beforeClose() {
      if (proxy._formParam?.options?.close && typeof proxy._formParam?.options?.close == 'function') {
        proxy._formParam.options.close();
      }
      proxy.super('beforeClose', baseReportParam);
    }
    function commandClick(command) {
      const me = proxy;
      switch (command) {
        case proxy.$ms.constant.Command.Ok:
          // validate control
          if (!me.validateComponents()) {
            nextTick(() => {
              me.focusFirstError();
            });
            return;
          }
          if (proxy.offlineReady) {
            // Nếu in khi mất mạng
            let dataModel = _.cloneDeep(proxy._report.dataModel);
            if (dataModel?.Detail?.length > 0) {
              dataModel.Detail = dataModel.Detail.filter(
                x => x.state != proxy.$ms.constant.ModelState.Delete && x.state != proxy.$ms.constant.ModelState.Empty,
              );
            }
            popupUtil.show('ReportOfflineDesigner', {
              dataVoucher: proxy._report.dataVoucher,
              dataModel: dataModel,
              param: proxy.model,
              report: proxy._report.report,
            });
            proxy.hide();
            return;
          }

          commonFn.mask();
          me.beforePrintReport();

          //Lưu lại params vào index db => load lại lần sau
          me._indexDb.set(me._formName, me.model);
          const param = {
            ...this._report, 
            ...{DataParam: {
                ...me.model,
                paramReportCommon: {
                  settingOptions : me.model?.settingOptions
                  },
              }
            }};

          param.ReportId = this._report.report_id;
          param.DataParam.ReportId = this._report.report_id;
          param.DataParam.RefID = me._formParam?.ref_id;
          param.DataParam.RefType = me._formParam?.ref_type;
          param.DataParam.IsSummarySameInfo = me.model.is_summary_same;
          param.IsBatchPrinting = me._report.is_batch_printing;
          param.IsSaveCommon = true; //Có lưu tham số in lần trước theo báo cáo không
          param.ReportIdCommon = me.reportIdCommon || me._formName; //Id chung cho báo cáo có 2 loại mẫu ngang, mẫu dọc cần lưu chung tham số in lần trước theo mẫu báo cáo
          param.ParamKey = me.getParamKey();
          this._report.reportName = this._report.report_name;
          api
            .saveParamter(param)
            .then(async result => {
              const formName = 'ReportPrintPreview';
              await popupUtil.hide(formName);
              //không ẩn mask để cho popup preview gọi ẩn đi
              popupUtil.show(formName, {
                report: this._report,
                key: result,
                param: param,
              });
              proxy.hide();
            })
            .catch(err => {
              commonFn.unmask();
              console.log(err);
              showError(err);
            });
          // }

          break;
      }
      proxy.pushTrans(command);
    }

    return {
      model,
      bindData,
      commandClick,
      pushTrans,
      beforeClose,
      loadRecentData,
      getParamKey,
      assignFormatRecentData,
      assignCommonRecentData
    };
  },
  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
    offlineReady() {
      if (!this.$store.state[ModuleOfflineWork]) return false;
      return this.$store.state[ModuleOfflineWork].offlineReady;
    },
  },
});
</script>
<style lang="scss">
.report-param-C4-08KB-TT19-2020 {
  .report-title {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-control-group {
      background-color: $ms-grey;
      cursor: pointer;
      font-size: $font-size;
      height: 100%;
      padding: 10px 15px;
      color: $grey-smoke;

      &.active {
        color: $black;
        border-bottom: 2px solid $primary;
        font-weight: $font-weight-semi-bold;
      }
    }
  }
  .report-body {
    display: flex;
    flex-direction: column;
    .report-tab {
      flex: 1;
      overflow: auto;
      &.tab-1 {
      }
      &.tab-2 {
        .ms-th-title.has-sort {
          padding-right: 10px;
        }
        .ms-editor.flex-column.h-auto {
          height: calc(100% - 70px);
        }
      }
      &.tab-3 {
        .title-3 {
          align-items: center;
          cursor: default;
          font-weight: $font-weight-semi-bold;
          margin-left: -8px;
        }
        .icon-combo--dropdown {
          border-radius: 0 4px 4px 0;
          width: $input-height;
          height: $input-height;
          position: relative;

          &:before {
            content: '';
            position: absolute;
            width: $input-height;
            height: $input-height;
            display: inline-block;
            background: transparent url($ms-image-sprites) no-repeat -334px -45px;
            top: 0px;
            left: 0px;
            transform: rotate(270deg);
            transition: all 0.3s ease;
          }
          &.multiple {
            position: sticky;
            top: 0px;
          }

          &.expand {
            &:before {
              transform: rotate(0deg);
            }
          }
        }
      }
      &.tab-4 {
      }
    }
    .seperator-line {
      border-top: 1px solid $secondary;
      width: 100%;
      &.tab-3 {
        border-top: 1px solid $secondary-active;
      }
    }
    .control-title {
      font-weight: $font-weight-medium;
    }
  }

  .ms-checkbox {
    &.left {
      margin-left: -4px !important;
    }
    input[type='checkbox']:disabled {
      background-color: $ms-grey;
    }
  }
  .align-center {
    align-items: center;
  }
  .footer-total-count .text-left {
    font-weight: $font-weight-semi-bold;
  }
  .ms-footer th {
    background: $ms-grey !important;
  }
}
</style>
